<svg class="absolute h-0 w-0 pointer-events-none" aria-hidden="true" focusable="false">
  <defs>
    <linearGradient id="club-medal-gold" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#FFF4BA" /><stop offset="0.22" stop-color="#D49B24" /><stop offset="0.45" stop-color="#FFF1A6" /><stop offset="0.7" stop-color="#B67C13" /><stop offset="1" stop-color="#EBC65B" />
    </linearGradient>
    <linearGradient id="club-medal-silver" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#FFFFFF" /><stop offset="0.22" stop-color="#94A3B8" /><stop offset="0.45" stop-color="#F8FAFC" /><stop offset="0.7" stop-color="#64748B" /><stop offset="1" stop-color="#CBD5E1" />
    </linearGradient>
    <linearGradient id="club-medal-bronze" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#FFD7B0" /><stop offset="0.22" stop-color="#B57542" /><stop offset="0.45" stop-color="#F7C795" /><stop offset="0.7" stop-color="#854522" /><stop offset="1" stop-color="#D9A06A" />
    </linearGradient>
    <linearGradient id="club-chocolate" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#AF7952" /><stop offset="0.3" stop-color="#754429" /><stop offset="1" stop-color="#3C2016" />
    </linearGradient>
    <linearGradient id="club-wrapper" x1="0" y1="0" x2="1" y2="0">
      <stop stop-color="#881337" /><stop offset="0.35" stop-color="#E8869C" /><stop offset="0.5" stop-color="#BE3459" /><stop offset="0.8" stop-color="#DB7590" /><stop offset="1" stop-color="#881337" />
    </linearGradient>
  </defs>
</svg>

<ng-template #pawMedal let-metal="metal" let-ink="ink" let-ribbon="ribbon">
  <svg class="h-11 w-10 mb-1 drop-shadow-sm" viewBox="0 0 48 56" fill="none" aria-hidden="true">
    <path d="M13 2h9l6 17-8 4L13 2Z" [attr.fill]="ribbon" />
    <path d="M26 2h9l-7 21-8-4 6-17Z" [attr.fill]="ribbon" opacity="0.75" />
    <path d="m16 3 6 16M32 3l-5 15" stroke="white" stroke-opacity="0.35" />
    <ellipse cx="25" cy="36" rx="19" ry="19" fill="#0F172A" opacity="0.15" />
    <circle cx="24" cy="34" r="19" [attr.fill]="metal" [attr.stroke]="ink" stroke-width="2" />
    <circle cx="24" cy="34" r="17" stroke="white" stroke-opacity="0.65" stroke-width="0.7" />
    <circle cx="24" cy="34" r="15" [attr.stroke]="ink" stroke-opacity="0.45" stroke-width="0.7" />
    <g [attr.fill]="ink" stroke="#FFFFFF" stroke-opacity="0.45" stroke-width="0.5">
      <ellipse cx="15" cy="31" rx="3" ry="4" transform="rotate(-25 15 31)" />
      <ellipse cx="21" cy="26" rx="3" ry="4" transform="rotate(-8 21 26)" />
      <ellipse cx="28" cy="26" rx="3" ry="4" transform="rotate(8 28 26)" />
      <ellipse cx="34" cy="31" rx="3" ry="4" transform="rotate(25 34 31)" />
      <path d="M24 33c-4 0-5 4-8 7-2 3 0 6 3 6 2 0 3-1 5-1s3 1 5 1c3 0 5-3 3-6-3-3-4-7-8-7Z" />
    </g>
    <path d="M9 28a16 16 0 0 1 15-10" stroke="white" stroke-opacity="0.8" stroke-width="1" stroke-linecap="round" />
    <path d="M38 40a16 16 0 0 1-13 10" [attr.stroke]="ink" stroke-opacity="0.5" stroke-width="1" stroke-linecap="round" />
  </svg>
</ng-template>

<div class="page">
    <app-page-header [title]="'clubsKiosk.title' | translate" [subtitle]="'clubsKiosk.subtitle' | translate">
      <p pageHeaderAside class="mt-2 text-xs font-medium text-slate-400">{{ 'clubsKiosk.referenceSeason' | translate }}</p>
      <div class="relative w-full sm:w-80">
        <input type="search" [value]="searchQuery()" (input)="onSearch($event)"
          [placeholder]="'clubsKiosk.searchPlaceholder' | translate" [attr.aria-label]="'clubsKiosk.searchPlaceholder' | translate"
          class="field pl-11">
        <svg class="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </app-page-header>

    <div class="mb-4 flex flex-wrap items-center gap-3">
      <div class="card flex flex-wrap items-center gap-1 rounded-2xl p-1.5" role="group" [attr.aria-label]="'clubsKiosk.statsPeriod' | translate">
        <button type="button" (click)="setStatsScope('season')"
          [class.accent-solid]="statsScope() === 'season'" [class.text-white]="statsScope() === 'season'"
          class="px-4 py-2 rounded-xl text-xs font-black uppercase tracking-wider text-slate-500 dark:text-slate-400 transition-colors">
          {{ 'common.season' | translate }}
        </button>
        <app-styled-select
          [options]="seasonOptions()"
          [value]="selectedSeasonStart().toString()"
          [ariaLabel]="'common.season' | translate"
          density="compact"
          (valueChange)="setSeasonStart($event)"
        />
        <button type="button" (click)="setStatsScope('all')"
          [class.accent-solid]="statsScope() === 'all'" [class.text-white]="statsScope() === 'all'"
          class="px-4 py-2 rounded-xl text-xs font-black uppercase tracking-wider text-slate-500 dark:text-slate-400 transition-colors">
          {{ 'clubsKiosk.allTime' | translate }}
        </button>
      </div>
      <div class="card flex flex-wrap items-center gap-2 rounded-2xl p-1.5 pl-4">
        <span class="text-xs font-bold text-slate-500 dark:text-slate-400">{{ 'clubsKiosk.sort.label' | translate }}</span>
        <app-styled-select [options]="sortOptions()" [value]="sortBy()" [ariaLabel]="'clubsKiosk.sort.label' | translate" density="compact" (valueChange)="setSort($event)" />
        <span class="pr-2 text-xs text-slate-400">{{ (sortBy() === 'alphabet' ? 'clubsKiosk.sort.alphabetOrder' : 'clubsKiosk.sort.order') | translate }}</span>
      </div>
    </div>
      <details class="group/stats mb-8 max-w-4xl">
        <summary class="flex w-fit cursor-pointer list-none items-center gap-2 rounded-full px-4 py-2 text-xs font-bold text-slate-500 transition-colors hover:bg-slate-200/60 hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-500 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-white [&::-webkit-details-marker]:hidden">
          <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
            <circle cx="12" cy="12" r="9" /><path d="M12 11v6m0-10v1" stroke-linecap="round" />
          </svg>
          {{ 'clubsKiosk.statsHelp.title' | translate }}
          <svg class="h-3 w-3 transition-transform group-open/stats:rotate-180" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </summary>
        <div class="card mt-3 p-5 sm:p-6">
          <p class="mb-5 text-sm leading-relaxed text-slate-500 dark:text-slate-400">{{ 'clubsKiosk.statsHelp.period' | translate }}</p>
          <dl class="grid grid-cols-1 gap-5 sm:grid-cols-2">
            @for (stat of ['distance', 'races', 'podiums', 'members']; track stat) {
              <div>
                <dt class="mb-1 text-sm font-bold text-slate-900 dark:text-white">{{ ('clubsKiosk.statsHelp.' + stat + 'Title') | translate }}</dt>
                <dd class="text-sm leading-relaxed text-slate-600 dark:text-slate-300">{{ ('clubsKiosk.statsHelp.' + stat) | translate }}</dd>
              </div>
            }
          </dl>
        </div>
      </details>

    @if (isLoading()) {
      <app-branded-loader [label]="'common.loading' | translate" />
    } @else {
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8">
        @for (club of filteredClubs(); track club.name) {
          <div class="group relative isolate rounded-3xl p-1 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-white/30 overflow-hidden"
            [style.background-color]="club.cardColor">
            <img [src]="club.backgroundImage" alt="" aria-hidden="true"
              class="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105">
            <div class="absolute inset-0 bg-gradient-to-b from-slate-950/20 via-slate-950/50 to-slate-950/90"></div>
            <div class="absolute inset-0 opacity-35" [style.background-color]="club.cardColor"></div>

            <div class="relative z-10 p-8 flex flex-col items-center h-full min-w-0">
               <!-- Club Avatar/Logo Placeholder -->
               <div class="w-24 h-24 shrink-0 rounded-full bg-white/90 flex items-center justify-center mb-6 shadow-inner ring-4 ring-white/60 overflow-hidden text-3xl font-black text-slate-400">
                 @if (club.logoUrl) {
                   <img [src]="club.logoUrl" [alt]="'Logo ' + club.name" class="h-full w-full object-contain p-1">
                 } @else {
                   {{ club.name.charAt(0) }}
                 }
               </div>

               @if (authService.isAdmin() && club.id) {
                 <input #logoInput type="file" class="hidden" accept="image/png,image/jpeg,image/webp"
                   (change)="onLogoSelected($event, club)" [disabled]="uploadingClubId() !== null">
                 <button type="button" (click)="logoInput.click()" [disabled]="uploadingClubId() !== null"
                   [attr.aria-label]="('clubsKiosk.changeLogo' | translate) + ' : ' + club.name"
                   [attr.title]="('clubsKiosk.changeLogo' | translate) + ' · ' + ('clubsKiosk.logoHint' | translate)"
                   [attr.aria-busy]="uploadingClubId() === club.id"
                   class="absolute top-3 right-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-950/30 text-white/70 transition-colors hover:bg-slate-950/60 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-white disabled:opacity-50">
                   @if (uploadingClubId() === club.id) {
                     <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                       <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" opacity="0.25" />
                       <path d="M12 3a9 9 0 0 1 9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                     </svg>
                   } @else {
                     <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                       <path d="m16 3 5 5M4 20l4-1 13-13a2.1 2.1 0 0 0-3-3L5 16l-1 4Z" stroke-linecap="round" stroke-linejoin="round" />
                     </svg>
                   }
                 </button>
                 @if (logoFeedback(); as feedback) {
                   @if (feedback.name === club.name) {
                     <p role="status" class="absolute top-14 inset-x-3 z-20 rounded-xl bg-slate-950/95 px-3 py-2 text-center text-sm"
                       [class.text-red-200]="feedback.error" [class.text-emerald-200]="!feedback.error">{{ feedback.key | translate }}</p>
                   }
                 }
               }

               <div class="h-[84px] w-full shrink-0 mb-2 flex items-center justify-center">
                 <h2 [attr.title]="club.name" class="w-full line-clamp-3 break-words text-xl leading-7 font-black text-white text-center uppercase tracking-tight drop-shadow-sm">
                   {{ club.name }}
                 </h2>
               </div>
               <span [attr.title]="club.region" class="h-4 w-full shrink-0 truncate text-center mb-4 text-[10px] leading-4 font-black uppercase tracking-widest text-white/80">{{ club.region }}</span>

               <!-- Main Stats Grid -->
               <div class="grid grid-cols-3 gap-2 w-full h-24 shrink-0 mb-8">
                 <!-- Podiums -->
                 <div class="flex flex-col items-center p-3 rounded-2xl bg-slate-50 dark:bg-slate-700/30 border border-slate-100 dark:border-slate-700/50">
                   <span class="text-2xl font-black text-amber-700 dark:text-amber-300">{{ club.podiums.total }}</span>
                    <span class="text-[10px] font-bold text-slate-400 uppercase tracking-tight mt-1">{{ 'clubsKiosk.podiums' | translate }}</span>
                 </div>

                 <!-- Distance -->
                 <div class="flex flex-col items-center p-3 rounded-2xl bg-slate-50 dark:bg-slate-700/30 border border-slate-100 dark:border-slate-700/50">
                    <span class="text-2xl font-black text-accent">{{ club.totalDistance | distance }}</span>
                    <span class="text-[10px] font-bold text-slate-400 uppercase tracking-tight mt-1">km</span>
                 </div>

                 <!-- Races -->
                 <div class="flex flex-col items-center p-3 rounded-2xl bg-slate-50 dark:bg-slate-700/30 border border-slate-100 dark:border-slate-700/50">
                    <span class="text-2xl font-black text-accent">{{ club.totalRaces }}</span>
                    <span [attr.title]="'clubsKiosk.racesHint' | translate" class="text-[10px] font-bold text-slate-400 uppercase tracking-tight mt-1">{{ 'clubsKiosk.races' | translate }}</span>
                 </div>
               </div>

               <!-- Detailed Medal Breakdown -->
               <div class="w-full grid grid-cols-4 gap-px bg-slate-100 dark:bg-slate-700/50 rounded-2xl p-1 mb-8 overflow-hidden">
                  <!-- GOLD -->
                  <div class="flex flex-col items-center py-3 bg-white dark:bg-slate-800 rounded-l-xl">
                    <span role="img" [attr.aria-label]="'clubsKiosk.goldMedal' | translate" [attr.title]="'clubsKiosk.goldMedal' | translate">
                      <ng-container [ngTemplateOutlet]="pawMedal" [ngTemplateOutletContext]="{ metal: 'url(#club-medal-gold)', ink: '#A16207', ribbon: '#2563EB' }" />
                    </span>
                    <span class="text-sm font-bold text-slate-700 dark:text-slate-300">{{ club.podiums.gold }}</span>
                  </div>
                  <!-- SILVER -->
                  <div class="flex flex-col items-center py-3 bg-white dark:bg-slate-800">
                    <span role="img" [attr.aria-label]="'clubsKiosk.silverMedal' | translate" [attr.title]="'clubsKiosk.silverMedal' | translate">
                      <ng-container [ngTemplateOutlet]="pawMedal" [ngTemplateOutletContext]="{ metal: 'url(#club-medal-silver)', ink: '#64748B', ribbon: '#64748B' }" />
                    </span>
                     <span class="text-sm font-bold text-slate-700 dark:text-slate-300">{{ club.podiums.silver }}</span>
                  </div>
                  <!-- BRONZE -->
                  <div class="flex flex-col items-center py-3 bg-white dark:bg-slate-800">
                    <span role="img" [attr.aria-label]="'clubsKiosk.bronzeMedal' | translate" [attr.title]="'clubsKiosk.bronzeMedal' | translate">
                      <ng-container [ngTemplateOutlet]="pawMedal" [ngTemplateOutletContext]="{ metal: 'url(#club-medal-bronze)', ink: '#9A3412', ribbon: '#EA580C' }" />
                    </span>
                     <span class="text-sm font-bold text-slate-700 dark:text-slate-300">{{ club.podiums.bronze }}</span>
                  </div>
                  <!-- CHOCOLATE -->
                  <div class="flex flex-col items-center py-3 bg-white dark:bg-slate-800 rounded-r-xl">
                    <span role="img" [attr.aria-label]="'clubsKiosk.chocolateBar' | translate" [attr.title]="'clubsKiosk.chocolateBar' | translate">
                      <svg class="h-11 w-10 mb-1 drop-shadow-sm" viewBox="0 0 48 56" fill="none" aria-hidden="true">
                        <rect x="10" y="5" width="28" height="46" rx="4" fill="#78350F" stroke="#451A03" stroke-width="2" />
                        <g fill="url(#club-chocolate)" stroke="#3C2016" stroke-width="1.5">
                          <rect x="13" y="8" width="10" height="11" rx="1.5" />
                          <rect x="25" y="8" width="10" height="11" rx="1.5" />
                          <rect x="13" y="21" width="10" height="11" rx="1.5" />
                          <rect x="25" y="21" width="10" height="11" rx="1.5" />
                        </g>
                        <path d="M15 10h6m6 0h6M15 23h6m6 0h6" stroke="#D0A17B" stroke-opacity="0.6" stroke-linecap="round" />
                        <path d="m10 34 7-3 7 3 7-3 7 3v3l-7-2-7 2-7-2-7 2v-3Z" fill="#CBD5E1" />
                        <path d="m10 37 7-2 7 2 7-2 7 2v10a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V37Z" fill="url(#club-wrapper)" />
                        <path d="M14 38h20M14 42h12" stroke="#FFE4E6" stroke-width="2" stroke-linecap="round" />
                      </svg>
                    </span>
                     <span class="text-sm font-bold text-slate-700 dark:text-slate-300">{{ club.podiums.chocolate }}</span>
                  </div>
               </div>

               <!-- Members Count -->
               <div class="flex items-center gap-2 mb-auto pl-2">
                 <div class="flex -space-x-2">
                   @for (i of [0,1,2]; track i) {
                     <div class="w-7 h-7 rounded-full border-2 border-white dark:border-slate-800 bg-slate-200 dark:bg-slate-700 flex items-center justify-center">
                       <svg class="w-3.5 h-3.5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                     </div>
                   }
                 </div>
                 <span [attr.title]="'clubsKiosk.membersHint' | translate" class="text-xs font-bold text-white/90">{{ 'clubsKiosk.memberCount' | translate:club.memberCount }}</span>
               </div>

               <a [routerLink]="['/club-profile', club.isIndependents ? '_INDEPENDENT_' : club.name]"
                  class="btn btn-primary mt-6 w-full">
                 {{ 'clubsKiosk.viewClub' | translate }}
               </a>
            </div>
          </div>
        }
      </div>
    }
  </div>
